import { render, staticRenderFns } from "./SideBarLink.vue?vue&type=template&id=5456c256&"
import script from "./SideBarLink.vue?vue&type=script&lang=js&"
export * from "./SideBarLink.vue?vue&type=script&lang=js&"
import style0 from "./SideBarLink.vue?vue&type=style&index=0&id=5456c256&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports